import { computed, observable, component } from 'knockout-decorators'

import { RecoveryStatus } from '@tixa/schema'
import { ErrorReporter, Language } from '~/utils'
import { pageState } from '~/store/page'

import type { SignInOptions } from '../utils/options'

import source from './recovery.html?raw'
import { authState } from '../utils/state'

@component('recovery-form', source)
export class RecoveryForm {
  constructor(private options: SignInOptions) {}
  private Locale = Language.getInstance()

  public i18n(key: string): string {
    return this.Locale.translations[key]
  }

  private state = authState
  @observable public isFeedbackVisible = false

  @computed get canRecover(): boolean {
    return (
      this.state.email.length > 0 &&
      this.state.userRecoveryKey.length > 0 &&
      this.state.password === this.state.password2 &&
      this.state.password.length > 7
    )
  }

  private gotoLogin() {
    if (this.state.isLoading) return
    this.options.signIn()
  }

  private async recoverAccount() {
    if (this.state.isLoading) return
    this.isFeedbackVisible = false
    this.state.isLoading = true

    let isSuccess = false

    try {
      const request = {
        email: this.state.email,
        appKey: this.state.appRecoveryKey,
        userKey: this.state.userRecoveryKey,
        password: this.state.password,
      }
      const response = await pageState.api.authentication.verifyRecovery(
        request
      )
      isSuccess = response.status === RecoveryStatus.success
    } catch (error) {
      ErrorReporter.exception(error as Error)
      this.isFeedbackVisible = true
    } finally {
      this.state.isLoading = false
    }

    if (isSuccess) {
      this.state.user = await pageState.api.user.GetUser()
      this.options.signedIn(this.state.email)
    } else {
      this.isFeedbackVisible = true
    }
  }
}
